import { useEffect, useRef } from "react";

export default function SectionAutoSaveWrapper({
  children,
  sectionId,
  onSectionExit,
}) {
  const sectionRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (sectionRef.current && !sectionRef.current.contains(event.target)) {
        // user clicked OUTSIDE this section
        onSectionExit(sectionId);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sectionId, onSectionExit]);

  return <div ref={sectionRef}>{children}</div>;
}
